import { render, staticRenderFns } from "./Kelnik.vue?vue&type=template&id=0ca5413b"
import script from "./Kelnik.vue?vue&type=script&lang=js"
export * from "./Kelnik.vue?vue&type=script&lang=js"
import style0 from "./Kelnik.vue?vue&type=style&index=0&id=0ca5413b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports